export type CategoryType = Partial<{
  type: number;
  num: string;
  label: string;
  slug: string;
  active_img_url: string | null;
  img_url: string | null;
  img_idx: number | null;
  thumbnail_img_url: string;
  icon_url: string | null;
  icon_active_url: string | null;
  color: string | null;
  special_category: number;
  url: string;
  key: string;
  name: string;
  top_img_url: string;
  tag_list: CategoryTagType[] | null;
  sub_categories: CategoryType[];
  slug: string;
}>;

export type CategoryTagType = Partial<{
  tag_key: string;
  tag_name: string;
}>;

/**族裔分类 */
export interface CuisineCategory {
  type?: number;
  special_type?: number;
  key: string;
  name?: string;
  color: string;
  active_img_url?: string;
  img_url?: string;
  top_img_url?: string;
  view_pos?: any;
  tag_list?: CuisineTagList[];
  is_new?: boolean;
  category_label?: any;
  url?: string;
}

export interface CuisineTag {
  tag_key: string;
  tag_name: string;
}

/**族裔二级分类 */
export interface SecondCuisineCategory {
  catalogue_num: string;
  catalogue_name: string;
  [key: string]: any;
}

export enum ShowType {
  normal = 'normal',
  group = 'group',
  vender = 'vender'
}

export enum FilterType {
  boolean = 'boolean',
  single = 'single',
  multiple = 'multiple'
}
